export default {
  DISCONNECTED: 'DISCONNECTED',
  PROCESSING: 'PROCESSING',
  CONNECTED: 'CONNECTED'
}